import React, { useEffect, useState } from 'react';
import { Button } from './Button';
import { Menu, X } from 'lucide-react';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-nova-navy-dark/95 backdrop-blur-md shadow-lg py-3' : 'bg-transparent py-5'}`} data-id="element-175">
      <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-176">
        <a href="#" className="flex items-center gap-2 z-50" data-id="element-177">
          <img src="https://cdn.magicpatterns.com/uploads/hAaMCrG6LwNRmp8NJ3EKxP/heylloyd-image-1771645896523.png" alt="Nova Digital Ventures Logo" className="h-10 w-auto object-contain bg-white rounded p-1" data-id="element-178" />
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-6" data-id="element-179">
          <a href="#servicios" className="text-sm font-medium text-gray-300 hover:text-nova-gold transition-colors" data-id="element-180">
            Servicios
          </a>
          <a href="#precios" className="text-sm font-medium text-gray-300 hover:text-nova-gold transition-colors" data-id="element-181">
            Precios
          </a>
          <a href="#faq" className="text-sm font-medium text-gray-300 hover:text-nova-gold transition-colors" data-id="element-182">
            FAQ
          </a>
          <Button href="#contacto" className="py-2.5 text-sm" data-id="element-183">
            Auditoría Gratis
          </Button>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-white z-50 p-2" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} data-id="element-184">
          {mobileMenuOpen ? <X size={24} data-id="element-185" /> : <Menu size={24} data-id="element-186" />}
        </button>

        {/* Mobile Nav */}
        <div className={`
          fixed inset-0 bg-nova-navy-dark flex flex-col items-center justify-center gap-8 transition-transform duration-300 ease-in-out
          ${mobileMenuOpen ? 'translate-x-0' : 'translate-x-full'}
          md:hidden
        `} data-id="element-187">
          <a href="#servicios" onClick={() => setMobileMenuOpen(false)} className="text-xl font-medium text-white hover:text-nova-gold" data-id="element-188">
            Servicios
          </a>
          <a href="#precios" onClick={() => setMobileMenuOpen(false)} className="text-xl font-medium text-white hover:text-nova-gold" data-id="element-189">
            Precios
          </a>
          <a href="#faq" onClick={() => setMobileMenuOpen(false)} className="text-xl font-medium text-white hover:text-nova-gold" data-id="element-190">
            FAQ
          </a>
          <Button href="#contacto" onClick={() => setMobileMenuOpen(false)} data-id="element-191">
            Auditoría Gratis
          </Button>
        </div>
      </div>
    </header>;
}